import React, { Fragment } from 'react'
import { Button } from '@drifthq/tide-core'
import cx from 'classnames'

import SkipForNow from 'components/SkipForNow'

import './style.css'

const PALETTE = [
  '#0176FF', '#EC1561', '#BC00E2', '#6734BA', '#3E4EB8', '#F7412D', '#30B1EF', '#00BCD6',
  '#009788', '#89C540', '#CDDE20', '#F0DD00', '#FFC200', '#FF9900', '#5F7D8C', '#333333',
]

const Swatch = ({ color, onClick, selected }) => (
  <div
    className={cx('setup-profile-swatch', { selected })}
    style={{
      backgroundColor: selected ? 'white' : color,
      border: `5px solid ${color}`,
    }}
    onClick={onClick}
  />
)

const ProfileColorStep = ({ onContinueClick, color: currentColor, onColorClick, onSkipClick }) => {
  return (
    <Fragment>
      <h1>Personalize your Conversational Sales Profile</h1>
      <p>Your Drift Profile is your digital business card where people can book meetings and chat in real time with you.</p>
      <label>Set your profile color</label>
      <div className="setup-profile-palette">
        {PALETTE.map(color => (
          <div key={color} className="setup-profile-swatch-container">
            <Swatch color={color} selected={currentColor === color} onClick={onColorClick(color)}/>
          </div>
        ))}
      </div>
      <Button onClick={onContinueClick}>Continue to Profile Details</Button>

      <SkipForNow handleClick={onSkipClick} path='/setup/profile/details' text='Skip for now'/>
    </Fragment>
  )
}

export default ProfileColorStep



// WEBPACK FOOTER //
// ./src/layouts/ProfileColorStep/component.js